/**
 * 카드결제 페이지 (레거시 _sky_m_10.php 대체)
 *
 * - 결제탭: 오더선택 → 금액/부가세 계산 → payat 카드결제 진행
 * - 직접입력: BS(BottomSheet)로 수동 결제내용 입력 (./Card/ManualPay)
 * - 내역탭: 전표(이미지) 보기 / 결제취소
 */
import ManualPay from './Card/ManualPay';
import Util from '../../Common/Util';

export default class Card {
    constructor() {
        // 회원·페이앳 값 (blade #page-data). 결제 후 돌아올 곳은 지금 호스트의 새 카드받기 내역
        this.cfg = Object.assign(JSON.parse(document.getElementById('page-data')?.textContent || '{}'), {
            returnUrl: 'https://' + location.host + '/m/cardpay?tab=hist',
        });
    }

    initialize() {
        this.initHandler();
        this.toggleClearBtn();
        this.showInfos(); // 초기화 (빈 상태)
        this.syncPayBtn(); // 브라우저가 체크 상태를 되살려 놓았을 수 있다
    }

    /** [카드결제] 버튼 — 사용 가능한 회원이 결제 동의에 체크했을 때만 열린다 */
    syncPayBtn() {
        const $btn = $('#payDoBtngo');
        $btn.prop('disabled', String($btn.data('use-ok')) !== '1' || !$('#agreepayments').is(':checked'));
    }

    initHandler() {
        const self = this;

        // 폼 제출(입력칸 엔터 등)은 막는다 — 결제는 [카드결제] 가 페이앳 주소로 보낸다 (옛 onsubmit="return false;")
        $('#mainForm').on('submit', (e) => e.preventDefault());

        // 오더 선택 드롭다운 열기
        $('#orderListsShow').on('click', () => self.openOrderList());

        // 선택 지우기
        $('#orderClearBtn').on('click', () => self.clearOrder());

        // 직접입력 → BS
        $('#InputOrderbtn').on('click', () => self.openManualPay());

        // 오더 항목 선택
        $(document).on('click', '.eaPayOrders', function () {
            const num = $(this).data('num');
            const paid = String($(this).data('paid')) === '1';
            const adr = $(this).data('adr');
            self.selectOrder(num, (paid ? '#결제된오더 ' : '') + adr, paid);
        });

        // 바깥 클릭 시 드롭다운 닫기
        $(document).on('click', (e) => {
            if (!$(e.target).closest('#orderToListDiv, #orderListsShow').length) {
                self.closeOrderList();
            }
        });

        // 부가세 별도/포함 변경
        $('#taxincluded1, #taxincluded2').on('change', () => self.priceChangeCheck());

        // 금액 직접수정
        $(document).on('keyup', '#payamount', function () {
            $j.Common.Form.formatNumberInput(this);
            self.priceChangeCheck();
        });

        // 카드결제
        $('#payDoBtngo').on('click', () => self.payProcess());
        $('#agreepayments').on('change', () => self.syncPayBtn());

        // 내역 — 전표 / 취소
        $(document).on('click', '.btn-receipt', function () {
            self.getReceipt($(this).data('num'));
        });
        $(document).on('click', '.btn-cancel-pay', function () {
            self.cancelPay($(this).data('num'));
        });
        // 전표 뷰 닫기/다운로드 (동적 생성 버튼 — 위임). 모듈 최상위에 두면 m.js 가 모든 화면에서 건다
        $(document).on('click', '.btn-recipt-close', () => {
            document.getElementById('orderToListDivHolder').style.display = 'none';
        });
        $(document).on('click', '.btn-recipt-download', () => self.downloadReceipt());
        $(document).on('click', '.btn-already-canceled', (e) => {
            e.preventDefault();
            Util.swalert('이미 취소된 결제입니다.');
        });
    }

    /* ================= 오더 선택 ================= */

    openOrderList() {
        const $show = $('#orderListsShow');
        const $box = $('#orderToListDiv');
        const rt = $show[0].getBoundingClientRect();
        const top = Math.round(rt.bottom + 4);
        const maxH = Math.max(120, Math.round($(window).height() - top - 20));
        $box.css({top: top + 'px', maxHeight: maxH + 'px', display: 'block'});
    }

    closeOrderList() {
        $('#orderToListDiv').hide();
    }

    selectOrder(num, text, paid) {
        this.closeOrderList();
        $('#orderLists').val(num);
        $('#orderListsShow').val(text);
        this.toggleClearBtn();
        this.showInfos(paid ? 'ask' : null);
    }

    /** 선택한 오더(직접입력 포함)를 지우고 결제 정보를 초기 상태로 되돌린다 */
    clearOrder() {
        this.closeOrderList();
        $('#orderLists').val('');
        $('#orderListsShow').val('');
        this.toggleClearBtn();

        // 결제 요청에 쓰이는 hidden 값도 함께 비운다 — 안 비우면 이전 오더 값이 남는다.
        ['ordernumber', 'member_name', 'workprice_orgin', 'workprice', 'taxprice',
            'fieldadress', 'ordermemno', 'workermemno', 'workdate', 'ordermanHP',
            'cashrealinputogo', 'memo_1'].forEach(id => $('#' + id).val(''));

        this.applyOrderInfo(null);
    }

    /** 고른 오더가 있을 때만 지우기(×) 버튼을 보인다 */
    toggleClearBtn() {
        $('#orderClearBtn').prop('hidden', $('#orderListsShow').val() === '');
    }

    /* ================= 오더 정보 로드 ================= */

    /**
     * 선택된 오더의 정보를 불러와 화면에 반영한다.
     * @param mode 'ask' 이면 결제된 오더 재결제 확인, 'confirmed' 이면 확인 완료
     */
    showInfos(mode) {
        const self = this;
        const orderNum = parseInt($('#orderLists').val(), 10);

        if (mode === 'ask') {
            Util.swalert(['전산상으로 이미 결제된 오더 입니다.\n이 오더를 다시 결제할까요?', 'question'], () => {
                self.showInfos('confirmed');
            }, ['확인', '아니오']);
            return;
        }

        if (isNaN(orderNum) || orderNum <= 0) {
            this.applyOrderInfo(null);
            return;
        }

        $('#ordernumber').val(orderNum);
        $.ajax({
            type: 'GET',
            url: `/m/ajax/order/${orderNum}`,
            success: (data) => self.applyOrderInfo(data),
        });
    }

    /**
     * 오더 정보(obj)를 결제 테이블/hidden 필드에 반영 (레거시 reset_orderInfos)
     */
    applyOrderInfo(obj) {
        const ids = ['ordernum', 'workday', 'workfield', 'workdaytype', 'workhour',
            'payamount_td', 'taxamt', 'workername', 'memphone', 'venpee', 'lastamount', 'vanafter'];
        ids.forEach(id => $('#' + id).html(''));

        if (!obj) return;

        const carPrice = parseInt(obj.car_price, 10) || 0;
        let taxAmt = 0;
        if ($('#taxincluded1').is(':checked')) {
            taxAmt = parseInt(carPrice * 0.1, 10);
        }
        const taxAfter = carPrice + taxAmt;
        const venpee = parseInt(taxAfter * 0.029, 10);
        const peeAfter = taxAfter - venpee;

        const orderNumX = parseInt(obj.order_num, 10);
        const showOrder = orderNumX === 9999999 ? '외부오더' : orderNumX;

        $('#ordernum').html(showOrder);
        $('#workday').html(obj.work_day);
        $('#workfield').text(Util.nvl(obj.site_address));
        $('#workdaytype').html(obj.car_workdaytype);
        $('#workhour').html(this.workdaytypeString(obj.car_workdaytype, obj.car_workhour));
        $('#payamount_td').html(`<input type="tel" id="payamount" name="payamount" data-amount-kor value="${Util.formatNumber(carPrice)}">`);
        $('#taxamt').html(Util.formatNumber(taxAmt) + ' 원');
        $('#workername').text(Util.nvl(obj.mem_name));
        $('#memphone').text(Util.nvl(obj.mem_phone));
        $('#venpee').html(Util.formatNumber(venpee) + ' 원');
        $('#lastamount').html(Util.formatNumber(taxAfter) + ' 원');
        $('#vanafter').html(Util.formatNumber(peeAfter) + ' 원');

        $('#ordernumber').val(obj.order_num);
        $('#member_name').val(obj.mem_name);
        $('#workprice_orgin').val(obj.car_price);
        $('#workprice').val(obj.car_price);
        $('#taxprice').val(taxAmt);
        $('#fieldadress').val(obj.site_address);
        $('#ordermemno').val(obj.order_member_num);
        $('#workermemno').val(obj.worker_owner_num);
        $('#workdate').val(obj.work_day);
        $('#ordermanHP').val(obj.mem_phone);
        $('#cashrealinputogo').val(peeAfter);
    }

    workdaytypeString(type, hour) {
        if (type === '일') return hour + '일';
        if (type === '오전' || type === '오후' || type === '시간') return hour + '시간';
        return hour;
    }

    /* ================= 금액 재계산 ================= */

    priceChangeCheck() {
        const $amt = $('#payamount');
        if (!$amt.length) return;

        let base = parseInt(String($('#workprice_orgin').val()).replace(/,/g, ''), 10) || 0;
        if (base === 0) {
            $('#workprice').val(0);
            $('#taxprice').val(0);
            $('#taxamt').html('0원');
            $('#lastamount').html('0원');
            $('#vanafter').html('0원');
            $('#cashrealinputogo').val(0);
            return;
        }
        $('#workprice').val(base);

        if ($('#taxincluded2').is(':checked')) {
            // 부가세 포함
            const supply = Math.ceil(base / 1.1);
            const tax = base - supply;
            $('#taxprice').val(parseInt(tax));
            $('#payamount').val(Util.formatNumber(parseInt(base - tax, 10)) + '원');
            $('#workprice').val(parseInt(base - tax));
            $('#taxamt').html(Util.formatNumber(parseInt(tax, 10)) + '원');
            $('#lastamount').html(Util.formatNumber(parseInt(base, 10)) + '원');

            const venpee = parseInt(base * 0.029, 10);
            const peeAfter = base - venpee;
            $('#venpee').html(Util.formatNumber(venpee) + '원');
            $('#vanafter').html(Util.formatNumber(peeAfter) + '원');
            $('#cashrealinputogo').val(peeAfter);
        } else {
            // 부가세 별도
            const tax = base * 0.1;
            const total = parseInt(base + tax);
            $('#payamount').val(Util.formatNumber(base) + '원');
            $('#workprice').val(parseInt(base));
            $('#taxprice').val(parseInt(tax));
            $('#taxamt').html(Util.formatNumber(parseInt(tax, 10)) + '원');
            $('#lastamount').html(Util.formatNumber(parseInt(total, 10)) + '원');

            const taxAfter = parseInt(base + tax);
            const venpee = parseInt(taxAfter * 0.029, 10);
            const peeAfter = taxAfter - venpee;
            $('#venpee').html(Util.formatNumber(venpee) + '원');
            $('#vanafter').html(Util.formatNumber(peeAfter) + '원');
            $('#cashrealinputogo').val(peeAfter);
        }
    }

    /* ================= 직접입력 (BS) ================= */

    openManualPay() {
        const self = this;
        this.closeOrderList();
        $('#orderLists').val('-9');
        $j.Ui.BS.open({
            target: new ManualPay(),
            data: {
                memberName: this.cfg.memberName,
                memberPhone: this.cfg.memberPhone,
                memberNo: this.cfg.memberNo,
                onApply: (result) => {
                    $('#memo_1').val(result.memo);
                    self.applyOrderInfo(result.obj);
                    $('#orderListsShow').val(result.obj.site_address);
                    self.toggleClearBtn();
                },
            },
        });
    }

    /* ================= 카드결제 진행 ================= */

    payProcess() {
        const fm = document.mainForm;

        if (!$('#payamount').length) {
            Util.swalert('결제 금액이 없습니다');
            return;
        }
        let amount = parseInt(String($('#payamount').val()).replace(/,/g, ''), 10) || 0;
        if (amount === 0) {
            Util.swalert('결제금액을 숫자만으로 입력해 주세요');
            return;
        }

        const mbNo = parseInt($('#mb_no').val(), 10) || 0;
        if (mbNo < 10) {
            Util.swalert('로그인 아이디가 없습니다. 다시 로그인해 주세요.');
            return;
        }
        if (!$('#agreepayments').is(':checked')) {
            Util.swalert('결제 이용 동의 후 진행해 주세요');
            return;
        }

        const workAmount = parseInt($('#workprice').val(), 10);
        const ordernum = parseInt($('#ordernumber').val(), 10);
        const orderMemno = parseInt($('#ordermemno').val(), 10);
        const workerMemno = parseInt($('#workermemno').val(), 10);

        if (isNaN(workerMemno) || workerMemno < 10) {
            Util.swalert('수주자가 없습니다.');
            return;
        }
        if (ordernum !== 9999999) {
            if (isNaN(orderMemno) || orderMemno < 10) {
                Util.swalert('발주자가 없습니다.');
                return;
            }
        }
        if (isNaN(workAmount) || workAmount < 1) {
            Util.swalert('금액을 입력해 주세요');
            return;
        }

        // payat 로 전달할 최종 결제금액(amount) / 면세(dutyfree) 계산 (레거시 pay_processdo 동일)
        let dutyfree = 0;
        if ($('#taxincluded1').is(':checked')) {
            // 부가세 별도 → amount = 공급가 + 부가세
            amount = workAmount + parseInt(workAmount * 0.1, 10);
        } else {
            // 부가세 포함 → amount = workprice(공급가), dutyfree = 부가세
            amount = workAmount;
            dutyfree = parseInt($('#taxprice').val(), 10) || 0;
        }

        let scname = this.cfg.venderIdChecked || 'skyjbc12';
        if (!scname || scname.length <= 3) scname = 'skyjbc12';

        const additionalData = [
            fm.playuniqsid.value,
            fm.workprice.value,
            fm.member_name.value,
            fm.ordermemno.value,
            fm.cashrealinputogo.value,
            fm.fieldadress.value,
            fm.taxprice.value,
        ].join('|');

        let chAdr = `https://www.payat.co.kr/madmin/card-keyin?access_token=${this.cfg.payatToken}` +
            `&store_screen_name=${scname}&employee_screen_name=${scname}`;
        chAdr += `&amount=${amount}&dutyfree=${dutyfree}` +
            `&comment=${encodeURIComponent('뒤로가기하시면 오더정보가 사라집니다. 현재 페이지에서 결제를 진행해 주세요')}` +
            `&additional_data=${additionalData}` +
            `&customer_name=${fm.vender_idChecked.value}` +
            `&customer_mobile=${mbNo}` +
            `&customer_phone=${fm.pay_bankaccount.value}` +
            `&customer_email=${fm.ordernumber.value}` +
            `&notice=&return_url=${encodeURIComponent(this.cfg.returnUrl)}`;

        $('#goAdrs').html(chAdr);

        Util.swalert(['위 정보로 결제를\n진행할까요?', 'question'], () => {
            const btn = document.getElementById('payDoBtngo');
            btn.value = '..... 결제 진행 중 .....';
            btn.disabled = true;
            location.href = chAdr;
        }, ['확인', '아니오']);
    }

    /* ================= 내역: 전표 / 취소 ================= */

    getReceipt(num) {
        $.ajax({
            type: 'GET',
            url: `/m/card/${num}`,
            success: (data) => {
                document.getElementById('reccImgTemp').innerHTML = data;
                const obj = document.getElementById('cardcond');
                html2canvas(obj).then((canvas) => {
                    const myImage = canvas.toDataURL('image/jpg');
                    // 모양은 _card.scss 「전표 뷰」(.recipt-btns)
                    const btns =
                        '<div class="recipt-btns">' +
                        '<input type="button" value="닫기" class="btn-recipt-close">&nbsp;' +
                        '<input type="button" value="다운로드" class="btn-recipt-download">' +
                        '</div>';
                    document.getElementById('recipetDiv').innerHTML =
                        `<img src="${myImage}" id="recFlyimg">` + btns;
                    document.getElementById('orderToListDivHolder').style.display = 'block';
                }).catch((err) => console.log(err));
            },
        });
    }

    downloadReceipt() {
        const img = document.getElementById('recFlyimg').src;
        const alink = document.createElement('a');
        alink.download = '매출전표.png';
        alink.href = img;
        document.body.appendChild(alink);
        alink.click();
        document.body.removeChild(alink);
    }

    cancelPay(num) {
        Util.swalert(['선택한 결제를 취소할까요??', 'question'], () => {
            $.ajax({
                type: 'delete',
                url: `/m/ajax/card/${num}`,
                dataType: 'json',
                success: (data) => {
                    if (data && data.result) {
                        Util.swalert('취소 요청 성공하였습니다.', () => location.reload());
                    } else {
                        Util.swalert('취소 요청이 실패하였습니다.');
                    }
                },
            });
        }, ['확인', '아니오']);
    }
}

